export const sessions = {

  methods: {
    getAccessToken(cognito,session) {
        var accessToken = ''
        if(cognito.isUseCognito){
          accessToken = session.getAccessToken().getJwtToken()
        } else {
          accessToken = session.accessToken
        }
        return accessToken
    }
  }
}